import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=59d88992&scoped=true&"
import script from "./ChangeStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatus.vue?vue&type=style&index=0&id=59d88992&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d88992",
  null
  
)

export default component.exports